import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalService, ModalConfig, ModalResult } from '../../services/modal.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modal-container',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss']
})
export class ModalContainerComponent implements OnInit, OnDestroy {
  showModal = false;
  config: ModalConfig | null = null;
  inputValue = '';
  private callback: ((result: ModalResult) => void) | null = null;
  private subscription?: Subscription;

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    this.subscription = this.modalService.modal$.subscribe(({ config, callback }) => {
      this.config = config;
      this.inputValue = config.inputValue || '';
      this.callback = callback;
      this.showModal = true;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  onConfirm(): void {
    if (this.callback) {
      this.callback({
        confirmed: true,
        value: this.config?.type === 'prompt' ? this.inputValue : undefined
      });
    }
    this.close();
  }

  onCancel(): void {
    if (this.callback) {
      this.callback({
        confirmed: false
      });
    }
    this.close();
  }

  close(): void {
    this.showModal = false;
    this.config = null;
    this.callback = null;
    this.inputValue = '';
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.onCancel();
    }
  }
}
